import { Button } from "@src/lib/ui/Button";
import { useCheckInsPageHeaderCreateSkillMutation } from "@src/features/library/check-ins/CheckInsPageHeader.generated";
import { useRouter } from "next/router";
import NewLibraryItemDialog from "./NewLibraryItemDialog";
import type { AiChatFragment } from "@src/features/assistantChat/aiChat.generated";
import { emptyTranslationSet } from "@src/features/knowledgeCheck/utils/prompts";
import { useToast } from "@src/lib/hooks/useToast";
import {
  OutlineFlowType,
  useOutlineFlow,
} from "@src/features/contentLibrary/outlineFlows.config";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onStartNewChat: () => void;
  initialInput?: string;
  enableChatHistory?: boolean;
  onSelectHistoricalChat?: (chat: AiChatFragment) => void;
  flowType: OutlineFlowType;
}

const OutlineSeedDialog: React.FC<Props> = ({
  open,
  onOpenChange,
  onStartNewChat,
  initialInput,
  enableChatHistory,
  onSelectHistoricalChat,
  flowType,
}) => {
  const router = useRouter();
  const { addErrorToast } = useToast();
  const config = useOutlineFlow(flowType);

  const [createSkillMutation] = useCheckInsPageHeaderCreateSkillMutation({
    onCompleted(data) {
      onOpenChange(false);
      if (data?.createSkill?.skill) {
        router.push({
          pathname: "/library/library-item/[id]",
          query: { id: data.createSkill.skill.libraryItem.id },
        });
      } else {
        addErrorToast({
          ...data?.createSkill,
          callsite: config.callsites.createDialog,
        });
      }
    },
    onError: () => {
      addErrorToast({
        callsite: config.callsites.createDialog,
      });
    },
  });

  const FooterButtons = (
    <>
      <Button
        variant="outline"
        className="flex-1"
        onClick={() => {
          createSkillMutation({
            variables: {
              input: {
                type: config.libraryItemType,
                name: emptyTranslationSet(),
                description: emptyTranslationSet(),
              },
            },
          });
        }}
      >
        {config.texts.newFromScratchLabel}
      </Button>
    </>
  );

  return (
    <NewLibraryItemDialog
      open={open}
      onOpenChange={onOpenChange}
      dialogTitle={config.texts.dialogTitle}
      contentTitle={config.texts.contentTitle}
      contentDescription={config.texts.contentDescription}
      chatType={config.chatType}
      FooterButtons={FooterButtons}
      onStartNewChat={onStartNewChat}
      placeholder={config.texts.placeholder}
      initialInput={initialInput}
      enableChatHistory={enableChatHistory}
      onSelectHistoricalChat={onSelectHistoricalChat}
    />
  );
};

export default OutlineSeedDialog;
